export default "__VITE_ASSET__BUdratDI__"